export const PhoneRegex = /\([2-9][0-8]\d\) [2-9]\d{2}-\d{4}/;
export const emailRegex = /^[a-zA-Z0-9_.+-]*@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
